import { createStyles } from "@envestnet/envreact-component-library";
import type { Theme, WithStyles } from "@envestnet/envreact-component-library";

const styles = (theme: Theme) =>
  createStyles({
    container: {},
    textfield: {
      paddingTop: 32,
      "& > *": {
        textAlign: "left",
      },
    },
    welcomeText: {
      ...theme.fonts.h4,
      paddingTop: 104,
    },
    createAccountText: {
      ...theme.fonts.p1,
      color: theme.colors.textSubtle,
      paddingTop: 8,
    },
    submitButton: {
      marginTop: 32,
      width: "100%",
    },
    errorContainer: {
      ...theme.fonts.caption,
      marginTop: 32,
      "& > span": {
        marginLeft: 3,
        position: "relative",
        top: 3,
      },
    },
  });

export type Styles = WithStyles<typeof styles>;
export default styles;
